import React from 'react';

import LoginHeader from '../components/login/LoginHeader';
import LoginForm from '../components/login/LoginForm';

const LoginPage = () => (
  <div id="page-container">
    <div className="login bg-black animated fadeInDown">
      <LoginHeader />
      <LoginForm />
    </div>
  </div>
);

export default LoginPage;
